import { NotchDevice } from './privateTypes';

const devicesWithDynamicIsland: NotchDevice[] = [
  {
    brand: 'Apple',
    model: 'iPhone 15',
  },
  {
    brand: 'Apple',
    model: 'iPhone 15 Plus',
  },
  {
    brand: 'Apple',
    model: 'iPhone 15 Pro',
  },
  {
    brand: 'Apple',
    model: 'iPhone 15 Pro Max',
  },
  {
    brand: 'Apple',
    model: 'iPhone 14 Pro',
  },
  {
    brand: 'Apple',
    model: 'iPhone 14 Pro Max',
  },
];

export default devicesWithDynamicIsland;
